import { SiteEntryProps } from '@ixicare/resources';
import * as React from 'react';
import DrawToolMapContainer from '../container/DrawToolMapContainer';

interface DrawToolProps {
  site: SiteEntryProps;
  planeId: number;
  headerSlot?: React.ReactNode;
}

const DrawTool: React.FC<DrawToolProps> = ({ site, planeId, headerSlot }) => {
  return <DrawToolMapContainer site={site} planeId={planeId} headerSlot={headerSlot} />;
};

export default DrawTool;
